var map = {
	"./icon-bank.svg": "48fc",
	"./icon-clipboard.svg": "2bcd",
	"./icon-coin-hand.svg": "2a11",
	"./icon-contract.svg": "c4aa",
	"./icon-incident.svg": "7bf2",
	"./icon-mobile-dollar.svg": "892e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4d76";